import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { resourceValidations, resourceValidationMessages } from '../../validations';
import { userResourceForm } from "../../forms";
import { Content, CustomForm, CustomInput, CustomSelect } from '../../../fgs';
import { Button, Col, Row } from 'reactstrap';
import * as Feather from 'react-feather';

import { createUserResource, RESOURCES_BASE_URL } from "../../../services/api";
import { resourceCategoryOptions } from "../../../services/selectOptions";

export const NewUserResourcePage = () => {
  const history = useHistory();
  const { userId } = useParams();
  const [form, setForm] = useState(userResourceForm);
  const [showResourceMedia, setShowResourceMedia] = useState(false);

  const onSelectChange = (name, selected) => {
    const selectedValue = selected ? selected : {};
    const newForm = Object.assign({}, form);
    newForm[name] = selectedValue.value;

    setForm(newForm);
  };

  const onInputChange = (e) => {
    const newForm = Object.assign({}, form);
    newForm[e.target.name] = e.target.value;

    setForm(newForm);
  };

  const onSave = () => {
    createUserResource(userId, form).then(() => {
      history.push(`/dashboard/users/${userId}/profile#resources`);
    });
  };

  const formControls = [
    { title: 'Salvar', props: { color: 'primary', type: 'submit' } },
    {
      title: 'Visualizar',
      props: {
        color: 'secondary',
        onClick: () => setShowResourceMedia(true),
        disabled: !form.path
      }
    },
    { title: 'Voltar', props: { color: 'secondary', onClick: () => history.goBack() } }
  ];

  const closeResourceMediaButton = () => {
    if (showResourceMedia) {
      const Icon = Feather.X;
      return (
        <Button
          className="btn-sm fixed-button"
          color="danger"
          onClick={() => setShowResourceMedia(false)}>
          <Icon />
        </Button>
      );
    }
  };

  const renderResourceMedia = () => {
    if (showResourceMedia) {
      return <iframe id="iframe-resource-media" src={`${RESOURCES_BASE_URL}${form.path}`} />;
    }
  };

  const renderForm = () => {
    if (showResourceMedia) return;

    return (
      <CustomForm
        validationMessages={resourceValidationMessages}
        validations={resourceValidations}
        form={form}
        formControls={formControls}
        onSubmit={onSave}>
        <Row>
          <Col xs="4">
            <CustomSelect
              labelText="Tipo"
              inputName="category"
              options={resourceCategoryOptions}
              onChange={onSelectChange} />
          </Col>
        </Row>

        <Row>
          <Col xs="6">
            <CustomInput
              labelText="Nome"
              hasIcon={true}
              iconName="Bookmark"
              iconPosition="prepend"
              inputName="name"
              placeholder="Recurso 1"
              onChange={onInputChange}
              inputValue={form.name} />
          </Col>

          <Col xs="6">
            <CustomInput
              labelText="Caminho"
              hasIcon={true}
              iconName="Map"
              iconPosition="prepend"
              inputName="path"
              placeholder="/points/user_1/"
              onChange={onInputChange}
              inputValue={form.path} />
          </Col>
        </Row>

      </CustomForm>
    );
  };

  return (
    <Content>
      {renderForm()}
      {closeResourceMediaButton()}
      {renderResourceMedia()}
    </Content>
  );
};